/**
 * Resolve the deployment-level default currency.
 *
 * Mirrors `useRagProxyBase.ts`: the value is surfaced via
 * `featureStore.defaultCurrency` (from `GET /api/features`'s
 * `default_currency`), with a `'USD'` fallback when the deployment
 * hasn't set `DEFAULT_CURRENCY` or the manifest hasn't loaded yet.
 *
 * Components that need the reactive value (e.g. a form label that should
 * update if the store changes) should use this hook. Non-React code
 * (services, event handlers, `@/utils/currency`'s `formatCents`) should
 * use `getDefaultCurrency()` instead.
 */

import { useFeatureStore } from '@/stores/featureStore'

const DEFAULT_CURRENCY = 'USD'

export function useDefaultCurrency(): string {
  return useFeatureStore(s => s.defaultCurrency) || DEFAULT_CURRENCY
}

/** Non-React accessor (services, event handlers, etc.). */
export function getDefaultCurrency(): string {
  return useFeatureStore.getState().defaultCurrency || DEFAULT_CURRENCY
}
